import { basisParam, getBasis } from "@app/lib/basis";
import { getPerspectiveId } from "@app/lib/perspective";
import CategorizationOverviewPage, {
  overviewQuery,
} from "@app/pages/categorization-overview/categorization-overview-page";
import type { categorizationOverviewPage_Query } from "@app/queries/categorizationOverviewPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/categorization-overview")({
  // Optional deep-link from /budgets: ?budget=<gid> loads that budget in planned mode.
  validateSearch: (search: Record<string, unknown>): { budget?: string } => ({
    budget: typeof search.budget === "string" ? search.budget : undefined,
  }),
  // Page-owned year (defaults to the current year server-side); exempt from the
  // global date-range lens.
  loader: () =>
    loadQuery<categorizationOverviewPage_Query>(
      environment,
      overviewQuery,
      {
        perspectiveId: getPerspectiveId() ?? undefined,
        basis: basisParam(getBasis()) ?? undefined,
      },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Categorization overview"),
  component: CategorizationOverviewRoute,
});

function CategorizationOverviewRoute() {
  const queryRef = Route.useLoaderData();
  const { budget } = Route.useSearch();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">
          Error loading the categorization overview
        </div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading categorization…</div>
        }
      >
        <CategorizationOverviewPage queryRef={queryRef} initialBudgetId={budget ?? null} />
      </Suspense>
    </ErrorBoundary>
  );
}
